import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/login'
import inlandTicket from './modules/inlandTicket'
import myApplication from './modules/myApplication'
import travelBooking from './modules/travelBooking'
Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    user,
    inlandTicket,
    myApplication,
    travelBooking
  },
  state: {
  },
  mutations: {
  },
  actions: {
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js